module.exports = __webpack_public_path__ + "static/rnz-032dc5dc221094f42f52e041d9e34f7a.jpg";